import { CardBody } from "reactstrap";
import { UL } from "../../../../AbstractElements";
import UserPlus from "./UserPlus";
import UserMinus from "./UserMinus";

const TotalUserBody = () => {
  return (
    <CardBody className="py-lg-3">
      <UL className="user-list simple-list d-flex flex-row">
        <UserPlus />
        <UserMinus />
      </UL>
    </CardBody>
  );
};

export default TotalUserBody;
